<template>
  <div>
    <div v-for="(item, index) in value" :key="index" class="kvass-image-text__item">
      <ImageComponent
        class="kvass-image-text__image"
        :value="{
          url: $path('image.url', item) || item.image,
          name: item.title,
          description: $path('image.description', item),
        }"
        v-bind="$attrs"
      />

      <div class="kvass-image-text__content">
        <slot name="content" v-bind="item">
          <h2 class="kvass-image-text__title">{{ item.title }}</h2>
          <div class="kvass-image-text__description" v-html="item.description"></div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from './mixin'
export default {
  mixins: [Mixin],
}
</script>
